module.exports = __webpack_public_path__ + "img/spotify.b9ff7d52.svg";